<template>
  <div>
    <div class="text-right">
      {{
        holidayCount > 0
          ? `Registros encontrados: ${holidayCount}`
          : 'No se han encontrado registros'
      }}
    </div>
    <b-table striped hover :items="holidays" :fields="tableHeader">
      <template #cell(isAllDay)="data">
        {{ data.item && data.item.isAllDay ? 'Completa' : 'Parcial' }}
      </template>
      <template #cell(dates)="data">
        <p class="m-0">
          Inicio Vigencia: <b>{{ data.item.initialDate }}</b>
        </p>
        <p class="m-0">
          Término Vigencia: <b>{{ data.item.finalDate }}</b>
        </p>
      </template>
      <template #cell(capacity)="data">
        <p class="m-0">
          AM: <b>{{ data.item.morningDisponibility }}</b>
        </p>
        <p class="m-0">
          PM: <b>{{ data.item.eveningDisponibility }}</b>
        </p>
      </template>
      <template #cell(action)="data">
        <b-dropdown no-flip text="Acción" class="mb-2 mr-2" variant="primary">
          <ul class="nav flex-column">
            <li class="nav-item">
              <a
                href="javascript:void(0);"
                class="nav-link"
                @click="openModal(data.item, 'update-holiday-data')"
                >Detalles</a
              >
            </li>
            <li class="nav-item">
              <a
                href="javascript:void(0);"
                class="nav-link"
                @click="manageDeleteHolidays(data.item.id)"
                >Eliminar</a
              >
            </li>
          </ul>
        </b-dropdown>
      </template>
    </b-table>
    <b-row>
      <b-col
        cols="12"
        md="6"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <label class="ml-1">Entries</label>
        <v-select
          v-model="pageQuantity"
          :options="perPageOptions"
          :clearable="false"
          class="per-page-selector d-inline-block ml-50 mr-1"
          @input="manageGetHolidays"
          :appendToBody="true"
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col
        cols="12"
        md="6"
        class="d-flex align-items-center justify-content-end"
      >
        <b-pagination
          class="pr-2 pt-1"
          align="right"
          v-if="holidays"
          v-model="getPage"
          :total-rows="holidayCount"
          :per-page="pageQuantity"
        />
      </b-col>
    </b-row>
<!--     <b-modal
      ref="modal-walkin"
      size="lg"
      centered
      title="Actualizar Sucursal"
      style="width: 70%"
      v-model="showModal"
    >
      <b-card-body>
        <b-list-group>
          <b-list-group-item v-for="locations">{}</b-list-group-item>
        </b-list-group>
      </b-card-body>
    </b-modal> -->
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import {
  BTable,
  BButton,
  BDropdown,
  BRow,
  BCol,
  BPagination,
} from 'bootstrap-vue'
import swal from 'sweetalert2'
import moment from 'moment'
import vSelect from 'vue-select'
import withPopper from '@/libs/vue-select'
import { getUserData } from '@/auth/utils'

export default {
  components: {
    BTable,
    BButton,
    BDropdown,
    BRow,
    BCol,
    BPagination,
    vSelect,
  },
  props: ['tableHeader'],
  data() {
    return {
      userData: getUserData(),
      perPageOptions: [5, 10, 25, 50, 100],
      withPopper,
    }
  },
  watch: {
    getPage: {
      handler(value) {
        this.setOffset(this.pageQuantity * (value - 1))
        this.manageGetHolidays()
      },
    },
  },
  computed: {
    ...mapState('holidays', ['holidays', 'holidayCount']),
    getPage: {
      get() {
        return this.$store.state.tableFilters.actualPage
      },
      set(value) {
        this.setActualPage(value)
      },
    },
    pageQuantity: {
      get() {
        return this.$store.state.tableFilters.pageQuantity
      },
      set(value) {
        this.setPageQuantity(value)
      },
    },
  },
  methods: {
    manageGetHolidays() {
      this.getHolidays()
        .then((response) => {})
        .catch((errors) => {})
    },
    manageDeleteHolidays(holidayId) {
      swal
        .fire({
          icon: 'warning',
          title: '¡Los datos se Eliminarán!',
          text: '¿Desea eliminar el horario personalizado seleccionado?',
          showCancelButton: true,
          cancelButtonText: 'Cancel',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí',
        })
        .then(async (result) => {
          if (result.value) {
            this.deleteHoliday(holidayId)
              .then((response) => {
                this.manageGetHolidays()
                swal.fire({
                  icon: 'success',
                  title: '¡Datos eliminado!',
                  timer: 35000,
                })
              })
              .catch((errors) => {})
          }
        })
    },
    ...mapActions('holidays', ['getHolidays', 'deleteHoliday']),
    ...mapMutations('tableFilters', [
      'setOffset',
      'setActualPage',
      'setPageQuantity',
    ]),
    getDateFormat(unix) {
      //return `${new Date(unix * 1000).toLocaleDateString("en-US")} ${new Date(unix * 1000).toLocaleTimeString("en-US")}`
      return moment.unix(unix).format('YYYY-MM-DD, h:mm:ss A')
    },
    openModal(holiday, type) {
      this.setSelectedHoliday(holiday)
      this.toggleModal({ value: true, type })
    },
    ...mapMutations('holidays', ['setSelectedHoliday']),
    ...mapMutations('locations', ['toggleModal']),
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

<style lang="scss" scoped>
.card-body {
  padding: 0px !important;
}
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>
